module.exports = __webpack_public_path__ + "static/media/game.f06803cb.mp4";